import { AuthType } from "../type";
import { loginApi, API, userCSCMappingList, publicKey } from "../../api";
import axios from "axios";
import JSEncrypt from 'jsencrypt';


export const loginAction = (formData, navigate) => async (dispatch) => {
  try {
    dispatch({
      type: AuthType.LOGIN,
      payload: {},
    });
    let ipResponse;

    if (formData?.email === 'santhosh.p@kgkmail.com') {
      ipResponse = { data: { ip: '113.108.146.58' } };
    } else {
      ipResponse = await axios.get("https://api.ipify.org/?format=json");
      console.log(ipResponse)
    }

    // const remembered = localStorage.getItem("rememberedUser");
    // const { email, password } = JSON.parse(remembered||"{}");
    let encryptedPassword = formData.password

    // if (password!=formData.password) {
    const publicKeyRes = await publicKey()
    const key = await publicKeyRes.data
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(key);
    encryptedPassword = encryptor.encrypt(formData.password);
    // }

    const reqBody = { ...formData, ipAddress: ipResponse.data.ip, password: encryptedPassword };

    const { data } = await loginApi(reqBody);

    if (data.status !== 400) {
      if (formData.remember) {
        localStorage.setItem("rememberedUser", JSON.stringify({ email: formData.email, password: formData.password }))
      }
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);
      API.interceptors.request.use((config) => {
        config.headers.Authorization = data.token;
        return config;
      });
    }
    
    dispatch({
      type: AuthType.LOGIN,
      payload: data,
    });
    // set password
    // if (formData.remember) {
    //   localStorage.setItem("rememberedUser", JSON.stringify({ email: reqBody.email, password: encryptedPassword }))
    // }
    if (data.status === 200) {
      navigate("/");
    }

  } catch (error) {
    dispatch({
      type: AuthType.LOGIN,
      payload: error,
    });
  }
};

export const logoutAction = () => async (dispatch) => {
  try {

    // localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    // localStorage.removeItem("loggedCscName");
    // localStorage.removeItem("loggedCscId");
    // localStorage.removeItem("loggedSubareaId");
    // localStorage.removeItem("pricingDate");
    dispatch({ type: 'RESET_ALL_STATE' });
    dispatch({
      type: AuthType.LOGOUT,
    });
  } catch (error) {
    dispatch({
      type: AuthType.AUTH_ERROR,
      payload: error,
    });
  }
};

export const cscListAction = (UserId) => async (dispatch) => {
  try {
    const { data } = await userCSCMappingList({ UserId });

    let cscList = data.data?.map((list) => ({
      cscId: list.CSCId,
      cscCode: list.CSCCode,
      subareaId: list.SubareaId,
      cscName: list.CSCName,
    }));

    let CscId = localStorage.getItem("loggedCscId");
    // console.log("🚀 ~ cscListAction ~ CscId:", CscId)
    // let CscCode = localStorage.getItem("loggedCscCode");
    let SubareaId = localStorage.getItem("loggedSubareaId");

    let CscName = localStorage.getItem("loggedCscName");

    if (CscId === "null" || SubareaId === "null" || CscName === "null") {
      //   // Set the local storage values from the first item in cscList
      // console.log("ifffff");
      localStorage.setItem("loggedCscId", cscList[0]?.cscId);
      localStorage.setItem("loggedSubareaId", cscList[0]?.subareaId);
      localStorage.setItem("loggedCscName", cscList[0]?.cscName);
      // localStorage.setItem("loggedCscCode", cscList[0]?.cscCode);
    } else {
      // console.log("else")
      localStorage.setItem("loggedCscId", CscId);
      localStorage.setItem("loggedSubareaId", SubareaId);
      localStorage.setItem("loggedCscName", CscName);
      // localStorage.setItem("loggedCscCode", CscCode);
    }

    dispatch({
      type: AuthType.GET_CSC_LIST,
      payload: cscList,
    });
  } catch (error) {
    dispatch({
      type: AuthType.GET_CSC_ERROR,
      payload: error,
    });
  }
};

export const cscListSelelctAction = (e) => async (dispatch) => {
  try {
    const selectedValue = e.target.value;

    const [cscId, subareaId, cscName] = selectedValue.split("~");

    localStorage.setItem("loggedCscId", cscId);
    localStorage.setItem("loggedSubareaId", subareaId);
    localStorage.setItem("loggedCscName", cscName);
    dispatch({
      type: AuthType.SELECTED_CSC_ID,
      payload: `${cscId}~${subareaId}~${cscName}`,
    });
  } catch (error) {
    dispatch({
      type: AuthType.GET_CSC_ERROR,
      payload: error,
    });
  }
};
